var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-layout-global.lit.scss';
import styles from './sds-layout.lit.scss';
import { SidebarUtilities } from '../utilities/sidebar';
import { classMap } from 'lit/directives/class-map.js';
import { SdsHeader } from '../header/sds-header.lit';
import { sdsCustomElement } from '../utilities/custom-components';
import { SidebarResizeHandler } from '../utilities/sidebar-resizing';
/**
 * `sds-layout` is a web component that provides a flexible layout structure for web applications.
 * It allows for customizable sidebar configuration and main layout management.
 *
 * ### Attributes
 * - `sidebar-width`: The width of the sidebar, specified in pixels or as a percentage.
 * - `sidebar-position`: The position of the sidebar, either 'left' or 'right'. Defaults to `'right'`.
 * - `sidebar`: The content of the sidebar, allowing for dynamic insertion of elements.
 * - `main-layout`: A boolean indicating if this layout serves as the main layout for the application.
 *
 * @tag sds-layout
 */
let SdsLayout = (() => {
    var _SdsLayout_card_accessor_storage, _SdsLayout_sidebarWidth_accessor_storage, _SdsLayout_sidebarPosition_accessor_storage, _SdsLayout_sidebar_accessor_storage, _SdsLayout_sidebarResizable_accessor_storage, _SdsLayout_mainLayout_accessor_storage, _SdsLayout__header_accessor_storage, _SdsLayout__layoutSidebarResizeHandler_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-layout')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _card_decorators;
    let _card_initializers = [];
    let _card_extraInitializers = [];
    let _sidebarWidth_decorators;
    let _sidebarWidth_initializers = [];
    let _sidebarWidth_extraInitializers = [];
    let _sidebarPosition_decorators;
    let _sidebarPosition_initializers = [];
    let _sidebarPosition_extraInitializers = [];
    let _sidebar_decorators;
    let _sidebar_initializers = [];
    let _sidebar_extraInitializers = [];
    let _sidebarResizable_decorators;
    let _sidebarResizable_initializers = [];
    let _sidebarResizable_extraInitializers = [];
    let _mainLayout_decorators;
    let _mainLayout_initializers = [];
    let _mainLayout_extraInitializers = [];
    let __header_decorators;
    let __header_initializers = [];
    let __header_extraInitializers = [];
    var SdsLayout = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsLayout_card_accessor_storage.set(this, __runInitializers(this, _card_initializers, void 0));
            _SdsLayout_sidebarWidth_accessor_storage.set(this, (__runInitializers(this, _card_extraInitializers), __runInitializers(this, _sidebarWidth_initializers, '')));
            _SdsLayout_sidebarPosition_accessor_storage.set(this, (__runInitializers(this, _sidebarWidth_extraInitializers), __runInitializers(this, _sidebarPosition_initializers, 'right')));
            _SdsLayout_sidebar_accessor_storage.set(this, (__runInitializers(this, _sidebarPosition_extraInitializers), __runInitializers(this, _sidebar_initializers, void 0)));
            _SdsLayout_sidebarResizable_accessor_storage.set(this, (__runInitializers(this, _sidebar_extraInitializers), __runInitializers(this, _sidebarResizable_initializers, void 0)));
            _SdsLayout_mainLayout_accessor_storage.set(this, (__runInitializers(this, _sidebarResizable_extraInitializers), __runInitializers(this, _mainLayout_initializers, void 0)));
            _SdsLayout__header_accessor_storage.set(this, (__runInitializers(this, _mainLayout_extraInitializers), __runInitializers(this, __header_initializers, void 0)));
            this._stylesGlobal = (__runInitializers(this, __header_extraInitializers), stylesGlobal);
            this._initialSidebarWidth = '';
            _SdsLayout__layoutSidebarResizeHandler_accessor_storage.set(this, null);
            this.toggleSidebar = () => {
                this.sidebar = this.sidebar === 'unfolded' ? 'folded' : 'unfolded';
                this.setAttribute('sidebar', this.sidebar);
            };
        }
        get card() { return __classPrivateFieldGet(this, _SdsLayout_card_accessor_storage, "f"); }
        set card(value) { __classPrivateFieldSet(this, _SdsLayout_card_accessor_storage, value, "f"); }
        /**
         * The width of the sidebar.
         * This attribute determines how wide the sidebar will be displayed.
         *
         * Defaults to `''`.
         *
         * @attr {number} sidebar-width - The width of the sidebar.
         */
        get sidebarWidth() { return __classPrivateFieldGet(this, _SdsLayout_sidebarWidth_accessor_storage, "f"); }
        set sidebarWidth(value) { __classPrivateFieldSet(this, _SdsLayout_sidebarWidth_accessor_storage, value, "f"); }
        /**
         * The position of the sidebar within the layout.
         * This attribute can be set to either 'left' or 'right', determining where the sidebar appears.
         *
         * Defaults to `'right'`.
         *
         * @attr {string} sidebar-position - The position of the sidebar.
         */
        get sidebarPosition() { return __classPrivateFieldGet(this, _SdsLayout_sidebarPosition_accessor_storage, "f"); }
        set sidebarPosition(value) { __classPrivateFieldSet(this, _SdsLayout_sidebarPosition_accessor_storage, value, "f"); }
        /**
         * The content of the sidebar.
         * This attribute allows for the insertion of dynamic content into the sidebar area.
         *
         * @attr {string} sidebar - The sidebar content.
         */
        get sidebar() { return __classPrivateFieldGet(this, _SdsLayout_sidebar_accessor_storage, "f"); }
        set sidebar(value) { __classPrivateFieldSet(this, _SdsLayout_sidebar_accessor_storage, value, "f"); }
        /**
         * Indicates whether the component is resizable.
         * When set to true, the component can be resized by the user.
         * @attr
         */
        get sidebarResizable() { return __classPrivateFieldGet(this, _SdsLayout_sidebarResizable_accessor_storage, "f"); }
        set sidebarResizable(value) { __classPrivateFieldSet(this, _SdsLayout_sidebarResizable_accessor_storage, value, "f"); }
        /**
         * Indicates if this layout is the main layout for the application.
         * When set to true, this attribute denotes that this layout serves as the primary interface.
         *
         * @attr {boolean} main-layout - If true, this layout is the main layout.
         */
        get mainLayout() { return __classPrivateFieldGet(this, _SdsLayout_mainLayout_accessor_storage, "f"); }
        set mainLayout(value) { __classPrivateFieldSet(this, _SdsLayout_mainLayout_accessor_storage, value, "f"); }
        get _header() { return __classPrivateFieldGet(this, _SdsLayout__header_accessor_storage, "f"); }
        set _header(value) { __classPrivateFieldSet(this, _SdsLayout__header_accessor_storage, value, "f"); }
        get _layoutSidebarResizeHandler() { return __classPrivateFieldGet(this, _SdsLayout__layoutSidebarResizeHandler_accessor_storage, "f"); }
        set _layoutSidebarResizeHandler(value) { __classPrivateFieldSet(this, _SdsLayout__layoutSidebarResizeHandler_accessor_storage, value, "f"); }
        get header() {
            return this._header;
        }
        async connectedCallback() {
            super.connectedCallback();
            this._initialSidebarWidth = this.sidebarWidth;
            this.updateSidebarWidth();
            if (this.hasAttribute('sidebar-resizable')) {
                await this.updateComplete;
                this._layoutSidebarResizeHandler = new SidebarResizeHandler(this, () => this.sidebarPosition, () => this.sidebarWidth, width => (this.sidebarWidth = width));
                this._layoutSidebarResizeHandler.initResize();
            }
            this.observeTextDirectionChanges();
        }
        disconnectedCallback() {
            var _a;
            (_a = this._layoutSidebarResizeHandler) === null || _a === void 0 ? void 0 : _a.destroy();
            super.disconnectedCallback();
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has('sidebar')) {
                this.updateSidebarWidth();
                this.passingFoldedToChild();
            }
        }
        updateSidebarWidth() {
            this.sidebarWidth = this.sidebar === 'folded' ? '56' : this._initialSidebarWidth;
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-layout', this._stylesGlobal.cssText);
            return html `
            <div class="${this.getClasses()}">
                <slot name="header" @slotchange="${() => this.addHeaderEventListener()}"></slot>
                <slot name="tabs"></slot>
                <div class="sds-layout__container">
                    ${this.sidebarWidth ? this.renderSidebar() : undefined}
                    <div
                        class="sds-layout__content ${this.sidebarPosition === 'left'
                ? 'sds-layout__content--left'
                : 'sds-layout__content--right'}"
                        part="sds-layout-content"
                        style="${this.sidebarWidth
                ? SidebarUtilities.getContentMargin(Number(this.sidebarWidth), this.sidebar, this.sidebarPosition)
                : undefined}"
                    >
                        <slot @slotchange="${() => this.requestUpdate()}"></slot>
                        ${'' /* @ToDO Kad:  tabs, card and grid slots should be removed after refactoring all use cases. */}
                        <slot name="card"></slot>
                        <slot name="grid"></slot>
                        <div
                            part="sds-layout-overlay"
                            class="sds-layout-overlay"
                            @click="${() => this.handleOverlayClick()}"
                        ></div>
                    </div>
                </div>
            </div>
        `;
        }
        handleOverlayClick() {
            if (this.sidebar) {
                this.sidebar = this.sidebar === 'unfolded' ? 'folded' : 'unfolded';
            }
        }
        renderSidebar() {
            return html `
            <div
                class="sds-layout__sidebar ${this.sidebarPosition === 'left'
                ? 'sds-layout__sidebar--left'
                : 'sds-layout__sidebar--right'}"
                part="sds-layout-sidebar"
                style="${SidebarUtilities.getSidebarStyles(Number(this.sidebarWidth), this.sidebar, this.sidebarPosition)}"
            >
                ${this.renderResizeBorder()}
                <slot
                    name="sidebar"
                    @slotchange="${() => {
                this.requestUpdate();
                this.passingFoldedToChild();
            }}"
                ></slot>
            </div>
        `;
        }
        renderResizeBorder() {
            if (this.sidebarResizable) {
                return html `<div id="resize-border" class="sds-layout__sidebar-resize-border"></div>`;
            }
        }
        passingFoldedToChild() {
            var _a;
            const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="sidebar"]');
            const assignedNodes = slot.assignedNodes({ flatten: true });
            const childNode = assignedNodes.find(node => node instanceof HTMLElement);
            if (childNode) {
                childNode.setAttribute('sidebar', this.sidebar);
                const sidebarElements = Array.from(childNode.querySelectorAll('[slot="sidebar"]'));
                sidebarElements.map(child => child.setAttribute('sidebar', this.sidebar));
            }
        }
        observeTextDirectionChanges() {
            const observer = new MutationObserver(() => {
                this.requestUpdate();
            });
            observer.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
        }
        firstUpdated() {
            this.addEventListener(SdsHeader.SIDEBAR_TOGGLE_EVENT, this.toggleSidebar);
        }
        addHeaderEventListener() {
            if (['unfolded', 'folded'].includes(this.sidebar)) {
                this._header.forEach((header) => {
                    header.addEventListener(SdsHeader.SIDEBAR_TOGGLE_EVENT, () => this.toggleSidebar);
                });
            }
        }
        getClasses() {
            return classMap({
                'sds-layout': true,
                'sds-layout--main': this.mainLayout,
                'sds-layout--sidebar-open': this.sidebar === 'open',
                'sds-layout--sidebar-unfolded': this.sidebar === 'unfolded',
                'sds-layout--sidebar-folded': this.sidebar === 'folded',
                'sds-layout--with-sidebar': this.sidebar,
            });
        }
    };
    _SdsLayout_card_accessor_storage = new WeakMap();
    _SdsLayout_sidebarWidth_accessor_storage = new WeakMap();
    _SdsLayout_sidebarPosition_accessor_storage = new WeakMap();
    _SdsLayout_sidebar_accessor_storage = new WeakMap();
    _SdsLayout_sidebarResizable_accessor_storage = new WeakMap();
    _SdsLayout_mainLayout_accessor_storage = new WeakMap();
    _SdsLayout__header_accessor_storage = new WeakMap();
    _SdsLayout__layoutSidebarResizeHandler_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsLayout");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _card_decorators = [queryAssignedElements({ slot: 'card' })];
        _sidebarWidth_decorators = [property({ type: Number, attribute: 'sidebar-width' })];
        _sidebarPosition_decorators = [property({ type: String, attribute: 'sidebar-position' })];
        _sidebar_decorators = [property({ type: String, reflect: true })];
        _sidebarResizable_decorators = [property({ type: Boolean, attribute: 'sidebar-resizable' })];
        _mainLayout_decorators = [property({ type: Boolean, attribute: 'main-layout' })];
        __header_decorators = [queryAssignedElements({ slot: 'header' })];
        __esDecorate(_classThis, null, _card_decorators, { kind: "accessor", name: "card", static: false, private: false, access: { has: obj => "card" in obj, get: obj => obj.card, set: (obj, value) => { obj.card = value; } }, metadata: _metadata }, _card_initializers, _card_extraInitializers);
        __esDecorate(_classThis, null, _sidebarWidth_decorators, { kind: "accessor", name: "sidebarWidth", static: false, private: false, access: { has: obj => "sidebarWidth" in obj, get: obj => obj.sidebarWidth, set: (obj, value) => { obj.sidebarWidth = value; } }, metadata: _metadata }, _sidebarWidth_initializers, _sidebarWidth_extraInitializers);
        __esDecorate(_classThis, null, _sidebarPosition_decorators, { kind: "accessor", name: "sidebarPosition", static: false, private: false, access: { has: obj => "sidebarPosition" in obj, get: obj => obj.sidebarPosition, set: (obj, value) => { obj.sidebarPosition = value; } }, metadata: _metadata }, _sidebarPosition_initializers, _sidebarPosition_extraInitializers);
        __esDecorate(_classThis, null, _sidebar_decorators, { kind: "accessor", name: "sidebar", static: false, private: false, access: { has: obj => "sidebar" in obj, get: obj => obj.sidebar, set: (obj, value) => { obj.sidebar = value; } }, metadata: _metadata }, _sidebar_initializers, _sidebar_extraInitializers);
        __esDecorate(_classThis, null, _sidebarResizable_decorators, { kind: "accessor", name: "sidebarResizable", static: false, private: false, access: { has: obj => "sidebarResizable" in obj, get: obj => obj.sidebarResizable, set: (obj, value) => { obj.sidebarResizable = value; } }, metadata: _metadata }, _sidebarResizable_initializers, _sidebarResizable_extraInitializers);
        __esDecorate(_classThis, null, _mainLayout_decorators, { kind: "accessor", name: "mainLayout", static: false, private: false, access: { has: obj => "mainLayout" in obj, get: obj => obj.mainLayout, set: (obj, value) => { obj.mainLayout = value; } }, metadata: _metadata }, _mainLayout_initializers, _mainLayout_extraInitializers);
        __esDecorate(_classThis, null, __header_decorators, { kind: "accessor", name: "_header", static: false, private: false, access: { has: obj => "_header" in obj, get: obj => obj._header, set: (obj, value) => { obj._header = value; } }, metadata: _metadata }, __header_initializers, __header_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsLayout = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsLayout = _classThis;
})();
export { SdsLayout };
